module.exports = __webpack_public_path__ + "img/icons B_13.6505cde5.png";